<template>
  <Header />
  <div class="container-fluid">
    <h1>Privacy</h1>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
}
</script>

<style>
</style>